import Pan from '../../../plugins/input/gestures/pan/Pan.js';
export default Pan;